<template>
  <div id="funki-terms-of-service" class="wd-bg-white wd-px-6 wd-py-6 <xs:wd-px-5 <xs:wd-pb-9">
    <h1 class="wd-text-otempmax wd-font-500 wd-mb-5">{{ title }}</h1>
    <client-only>
      <div class="content" v-html="content" />
    </client-only>
  </div>
</template>

<script lang="ts" setup>
const i18n = useI18n()

const title = computed(() => i18n.t('funki_tos_title'))
const content = computed(() => i18n.t('funki_tos_content'))
</script>

<style lang="scss">
main:has(#funki-terms-of-service) {
  @apply bg-white !important;
}
#funki-terms-of-service {
  h2 {
    @apply text-otemplg font-500 mb-5;
  }
  p {
    @apply text-sm font-700 mb-4;
  }
  ul,
  ol {
    @apply text-sm font-400 mb-4 list-outside pl-6;
  }
  section {
    @apply mb-10;
    p {
      @apply font-400;
    }
  }
}
</style>
